export default __webpack_public_path__ + "static/media/badscript.634cfdef.woff2";